import { createSlice } from '@reduxjs/toolkit'

const companyLogoStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: companyLogoStatus.LOADING,
    logo: null,
    companyName: '',
    has404Error: false,
}

const companyLogoSlice = createSlice({
    name: 'companyLogo',
    initialState,
    reducers: {
        getCompanyLogoRequest: state => {
            state.status = companyLogoStatus.LOADING
        },
        getCompanyLogoRequestSuccess: (state, action) => {
            state.status = companyLogoStatus.SUCCESS
            const { logo, companyName } = action.payload
            state.logo = logo
            state.companyName = companyName
        },
        getCompanyLogoRequestError: (state, action) => {
            state.status = companyLogoStatus.FAILURE
            state.has404Error = action.payload
        },
    },
})

const {
    getCompanyLogoRequest,
    getCompanyLogoRequestSuccess,
    getCompanyLogoRequestError,
} = companyLogoSlice.actions

export const companyLogoActions = {
    getCompanyLogoRequest,
    getCompanyLogoRequestSuccess,
    getCompanyLogoRequestError,
}

export const companyLogoSelectors = {
    logo: state => state.companyLogo.logo,
    companyName: state => state.companyLogo.companyName,
    isFetching: state => state.companyLogo.status === companyLogoStatus.LOADING,
    hasError: state => state.companyLogo.status === companyLogoStatus.FAILURE,
    has404Error: state => state.companyLogo.has404Error,
}

const companyLogoReducer = companyLogoSlice.reducer

export default companyLogoReducer
